export enum ToolItemAction {
  Edit = 'edit',
  Copy = 'copy',
  Delete = 'delete',
  Enable = 'enable',
  Disable = 'disable',
  Download = 'download',
}

export interface ToolItemActionPermissions extends Partial<Record<ToolItemAction, boolean>> {}
